module.exports = __webpack_public_path__ + "img/pragmatic.4161507d.svg";